import {MouseEvent, useLayoutEffect, useState} from "react";
import {css} from "@panda/css";

import {ChevronRightIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {priceM2Format} from "@pg-mono/string-utils";

import {PricesViewType} from "../../helpers/prices_view_type";
import {
    IPricesHubTableHoverMetrics,
    PRICES_HUB_TABLE_HOVER_OVERFLOW_X_PX,
    PRICES_HUB_TABLE_HOVER_OVERFLOW_Y_PX
} from "../../hooks/use_prices_hub_table_row_hover";
import {trackPricesCityDistrictRowClick} from "../../tracking/track_prices_city_district_row_click";
import {DistrictRow} from "../../types/DistrictRow";
import {getDistrictListingLink} from "../../utils/get_district_listing_link";
import {PricesDistrictChangeBadge} from "./PricesDistrictChangeBadge";

interface Props {
    district: DistrictRow;
    metrics: IPricesHubTableHoverMetrics;
    isVisible: boolean;
    onMouseMove: (event: MouseEvent<HTMLAnchorElement>) => void;
    citySlug: string;
    type: PricesViewType;
}

export const PricesDistrictTableHoverRow = (props: Props) => {
    const {district, metrics, isVisible, onMouseMove, citySlug, type} = props;
    const href = getDistrictListingLink(district, citySlug, type);
    const [nameWidth = 0, currentOfferWidth = 0, yearAgoOfferWidth = 0, badgeWidth = 0, actionWidth = 0] = metrics.columns;
    const [opacity, setOpacity] = useState(0);

    useLayoutEffect(() => {
        if (!isVisible) {
            setOpacity(0);
            return;
        }

        const timeout = window.setTimeout(() => setOpacity(1), 0);

        return () => window.clearTimeout(timeout);
    }, [isVisible]);

    return (
        <a
            href={href}
            tabIndex={-1}
            aria-label={`Zobacz ceny mieszkań – ${district.name}`}
            className={overlayStyle}
            style={{
                top: metrics.top - PRICES_HUB_TABLE_HOVER_OVERFLOW_Y_PX,
                height: metrics.height + PRICES_HUB_TABLE_HOVER_OVERFLOW_Y_PX * 2,
                opacity,
                pointerEvents: isVisible ? "auto" : "none",
                // Badge and action are merged into one flex cell below (rather than kept as the real
                // table's own narrow fixed columns) so the "Pokaż oferty" label has room to push in next
                // to the badge - the real table's action column is only ever sized for a bare chevron.
                gridTemplateColumns: `${nameWidth + PRICES_HUB_TABLE_HOVER_OVERFLOW_X_PX}px ${currentOfferWidth}px ${yearAgoOfferWidth}px ${
                    badgeWidth + actionWidth + PRICES_HUB_TABLE_HOVER_OVERFLOW_X_PX
                }px`
            }}
            onMouseMove={onMouseMove}
            onClick={() => trackPricesCityDistrictRowClick(district, href)}
        >
            <Text as="span" variant="body_copy_1" className={nameCellStyle}>
                {district.name}
            </Text>

            <Text as="span" variant="body_copy_1" className={numberCellStyle}>
                {district.offerPriceM2 !== null ? priceM2Format(district.offerPriceM2) : "Brak danych"}
            </Text>

            <Text as="span" variant="body_copy_1" className={numberCellStyle}>
                {district.yearAgoOfferPriceM2 !== null ? priceM2Format(district.yearAgoOfferPriceM2) : "Brak danych"}
            </Text>

            <div className={badgeActionCellStyle}>
                <PricesDistrictChangeBadge yearOverYearPct={district.yearOverYearPct} className={badgeStyle} />

                <Text as="span" variant="info_txt_1" color="var(--colors-white)" style={{textAlign: "center", whiteSpace: "nowrap"}}>
                    Pokaż oferty
                </Text>

                <ChevronRightIcon size="2.2" fill="currentColor" />
            </div>
        </a>
    );
};

const overlayStyle = css({
    position: "absolute",
    left: 0,
    zIndex: 2,
    display: "grid",
    alignItems: "center",
    width: "100%",
    cursor: "pointer",
    color: "var(--colors-white)",
    textDecoration: "none",
    backgroundColor: "var(--colors-secondary)",
    borderRadius: "1.4rem",
    boxShadow: "0 2px 6px 0 rgba(35, 35, 45, 0.12), 0 14px 32px -6px rgba(35, 35, 45, 0.3)",
    transition: "opacity 220ms ease, top 70ms ease-out, height 70ms ease-out",

    _hover: {
        color: "var(--colors-white)",
        textDecoration: "none"
    },

    _focusVisible: {
        outline: "2px solid var(--colors-primary)",
        outlineOffset: "2px"
    },

    "@media (prefers-reduced-motion: reduce)": {
        transition: "none"
    }
});

const nameCellStyle = css({
    pl: "2.6rem",
    color: "var(--colors-white)"
});

const numberCellStyle = css({
    px: 1.5,
    textAlign: "center",
    color: "rgba(255, 255, 255, 0.92)",
    whiteSpace: "nowrap"
});

const badgeActionCellStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: 2,
    pl: 1.5,
    pr: "2.2rem"
});

const badgeStyle = css({
    color: "var(--colors-secondary)"
});
import {MouseEvent, useLayoutEffect, useState} from "react";
import {css} from "@panda/css";

import {ChevronRightIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {priceM2Format} from "@pg-mono/string-utils";

import {PricesViewType} from "../../helpers/prices_view_type";
import {
    IPricesHubTableHoverMetrics,
    PRICES_HUB_TABLE_HOVER_OVERFLOW_X_PX,
    PRICES_HUB_TABLE_HOVER_OVERFLOW_Y_PX
} from "../../hooks/use_prices_hub_table_row_hover";
import {trackPricesCityDistrictRowClick} from "../../tracking/track_prices_city_district_row_click";
import {DistrictRow} from "../../types/DistrictRow";
import {getDistrictListingLink} from "../../utils/get_district_listing_link";
import {PricesDistrictChangeBadge} from "./PricesDistrictChangeBadge";

interface Props {
    district: DistrictRow;
    metrics: IPricesHubTableHoverMetrics;
    isVisible: boolean;
    onMouseMove: (event: MouseEvent<HTMLAnchorElement>) => void;
    citySlug: string;
    type: PricesViewType;
}

export const PricesDistrictTableHoverRow = (props: Props) => {
    const {district, metrics, isVisible, onMouseMove, citySlug, type} = props;
    const href = getDistrictListingLink(district, citySlug, type);
    const [nameWidth = 0, currentOfferWidth = 0, yearAgoOfferWidth = 0, badgeWidth = 0, actionWidth = 0] = metrics.columns;
    const [opacity, setOpacity] = useState(0);

    useLayoutEffect(() => {
        if (!isVisible) {
            setOpacity(0);
            return;
        }

        const timeout = window.setTimeout(() => setOpacity(1), 0);

        return () => window.clearTimeout(timeout);
    }, [isVisible]);

    return (
        <a
            href={href}
            tabIndex={-1}
            aria-label={`Zobacz ceny mieszkań – ${district.name}`}
            className={overlayStyle}
            style={{
                top: metrics.top - PRICES_HUB_TABLE_HOVER_OVERFLOW_Y_PX,
                height: metrics.height + PRICES_HUB_TABLE_HOVER_OVERFLOW_Y_PX * 2,
                opacity,
                pointerEvents: isVisible ? "auto" : "none",
                // Badge and action are merged into one flex cell below (rather than kept as the real
                // table's own narrow fixed columns) so the "Pokaż oferty" label has room to push in next
                // to the badge - the real table's action column is only ever sized for a bare chevron.
                gridTemplateColumns: `${nameWidth + PRICES_HUB_TABLE_HOVER_OVERFLOW_X_PX}px ${currentOfferWidth}px ${yearAgoOfferWidth}px ${
                    badgeWidth + actionWidth + PRICES_HUB_TABLE_HOVER_OVERFLOW_X_PX
                }px`
            }}
            onMouseMove={onMouseMove}
            onClick={() => trackPricesCityDistrictRowClick(district, href)}
        >
            <Text as="span" variant="body_copy_1" className={nameCellStyle}>
                {district.name}
            </Text>

            <Text as="span" variant="body_copy_1" className={numberCellStyle}>
                {district.offerPriceM2 !== null ? priceM2Format(district.offerPriceM2) : "Brak danych"}
            </Text>

            <Text as="span" variant="body_copy_1" className={numberCellStyle}>
                {district.yearAgoOfferPriceM2 !== null ? priceM2Format(district.yearAgoOfferPriceM2) : "Brak danych"}
            </Text>

            <div className={badgeActionCellStyle}>
                <PricesDistrictChangeBadge yearOverYearPct={district.yearOverYearPct} className={badgeStyle} />

                <Text as="span" variant="info_txt_1" color="var(--colors-white)" style={{textAlign: "center", whiteSpace: "nowrap"}}>
                    Pokaż oferty
                </Text>

                <ChevronRightIcon size="2.2" fill="currentColor" />
            </div>
        </a>
    );
};

const overlayStyle = css({
    position: "absolute",
    left: 0,
    zIndex: 2,
    display: "grid",
    alignItems: "center",
    width: "100%",
    cursor: "pointer",
    color: "var(--colors-white)",
    textDecoration: "none",
    backgroundColor: "var(--colors-secondary)",
    borderRadius: "1.4rem",
    boxShadow: "0 2px 6px 0 rgba(35, 35, 45, 0.12), 0 14px 32px -6px rgba(35, 35, 45, 0.3)",
    transition: "opacity 220ms ease, top 70ms ease-out, height 70ms ease-out",

    _hover: {
        color: "var(--colors-white)",
        textDecoration: "none"
    },

    _focusVisible: {
        outline: "2px solid var(--colors-primary)",
        outlineOffset: "2px"
    },

    "@media (prefers-reduced-motion: reduce)": {
        transition: "none"
    }
});

const nameCellStyle = css({
    pl: "2.6rem",
    color: "var(--colors-white)"
});

const numberCellStyle = css({
    px: 1.5,
    textAlign: "center",
    color: "rgba(255, 255, 255, 0.92)",
    whiteSpace: "nowrap"
});

const badgeActionCellStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: 2,
    pl: 1.5,
    pr: "2.2rem"
});

const badgeStyle = css({
    color: "var(--colors-secondary)"
});
